/** Délai maximal sur une promesse. PUR (horloge du navigateur). */
export class TimeoutError extends Error {
  constructor(label: string, ms: number) {
    super(`${label} : pas de réponse en ${String(ms)} ms`);
    this.name = 'TimeoutError';
  }
}

/** Rejette avec `TimeoutError` si `promise` n'est pas réglée en `ms`. */
export function withTimeout<T>(promise: Promise<T>, ms: number, label: string): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new TimeoutError(label, ms));
    }, ms);
    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (e: unknown) => {
        clearTimeout(timer);
        reject(e instanceof Error ? e : new Error(String(e)));
      },
    );
  });
}
